import $ from "jquery"

$(function() {
    const $overlaymenu = $("#overlaymenu");
    const $body = $("body");

    function toggleMenu() {
        const newvisible = !$overlaymenu.hasClass("visible");
        $overlaymenu.toggleClass("visible", newvisible);
        $body.toggleClass("overlaymenuvisible", newvisible);
    }

    const $menubuttons = $(".menubutton"); //Bei Projektdetails: 2 Menubuttons (Responsive Variante des Headers)
    $menubuttons.on("click", toggleMenu);

    const $closebutton = $overlaymenu.find(".closebutton");
    $closebutton.on("click", toggleMenu);
});